import { initAllServiceLocator } from './service-locator'

export default () => {
  initAllServiceLocator()
}
